import { isCompositeFilter } from "../../models/CompositeFilterModel";
import type { SearchFilterInstance } from "../../types/searchFilterInstance";

import type { IPinService } from "./types";

export const createPinService = (): IPinService => {
    const getInstancePinKeys = (instance: SearchFilterInstance): readonly string[] =>
        isCompositeFilter(instance.filter) ? instance.filter.getFieldKeys() : [instance.key];

    const instanceMatchesPin = (instance: SearchFilterInstance, persistedKeys: ReadonlySet<string>): boolean =>
        isCompositeFilter(instance.filter)
            ? instance.filter.getFieldKeys().some((memberKey) => persistedKeys.has(memberKey))
            : persistedKeys.has(instance.key);

    const resolveInstancePinKeys = (config: readonly SearchFilterInstance[], key: string): readonly string[] => {
        const instance = config.find((filter) => filter.key === key);

        return instance ? getInstancePinKeys(instance) : [key];
    };

    const isInstancePinnedByKey = (
        config: readonly SearchFilterInstance[],
        key: string,
        persistedKeys: ReadonlySet<string>,
    ): boolean => {
        const instance = config.find((filter) => filter.key === key);

        return instance ? instanceMatchesPin(instance, persistedKeys) : persistedKeys.has(key);
    };

    return {
        resolveInstancePinKeys,
        instanceMatchesPin,
        isInstancePinnedByKey,
    };
};
